import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    create_Contract,
    get_Contract_Data,
    get_Single_Package,
    get_Contract_Info,
    get_Contract_Template,
    get_Template_Content,
    last_Five_Contract,
    get_AllQuotes,
    delete_Contract,
    request_Higher_Discount,
    client_Details_UpdateApi,
    DownloadContract
} from '../../../Service/Contract/contractService'
const UserId = JSON.parse(localStorage.getItem("agent_id"));


export const clientDetailsUpdateApi = createAsyncThunk("client_details_update", async (data) => {
    try { 
        const res = await client_Details_UpdateApi(data);
        return await res;
    } catch (err) {
        return err;
    }
});           


export const requestHigherDiscount = createAsyncThunk("request_higher_discount", async (data) => {
    try { 
        const res = await request_Higher_Discount(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const createContract = createAsyncThunk("create_contract", async (data) => {
    try { 
        const res = await create_Contract(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const getContractData = createAsyncThunk("get_contract", async (data) => {
    try {
        const res = await get_Contract_Data(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const getContractTemplate = createAsyncThunk("getContractTemplate", async (data) => {
    try { 
        const res = await get_Contract_Template(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const getTemplateContent = createAsyncThunk("contract/gettemplatecontent", async (data) => {
    try { 
        const res = await get_Template_Content(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const getContractInfo = createAsyncThunk("getConractInfo", async (data) => {
    try {
        const res = await get_Contract_Info(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const getSinglePackage = createAsyncThunk("get_contract_ps", async (data) => {
    try {
        
        const res = await get_Single_Package(data);
        return await res;
    } catch (err) {
        return err;
    }
});


export const lastFiveContract = createAsyncThunk("LastFiveContracts", async (data) => {
    try {
        const res = await last_Five_Contract(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const deleteContract = createAsyncThunk("delete_contract", async (data) => {
    try {
        const res = await delete_Contract(data);
        return await res;
    } catch (err) {
        return
    }
});

export const getAllQuotes = createAsyncThunk("getAllContracts", async (data) => {
    try {
        const res = await get_AllQuotes(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const getAllContracts = createAsyncThunk("getAllContracts", async (data) => {
    try {
        const res = await get_AllQuotes(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const downloadContract = createAsyncThunk("dawnloadcontract", async (data) => {
    try {
        const res = await DownloadContract(data);
        return await res;
    } catch (err) {
        return
    }
    }
);




const QuoteSlice = createSlice({
    name: "QuoteSlice",
    initialState: {
        isLoading: false,
        isError: false,
        createcontract: [],
        getcontractData: [],
        getsinglepackage: [],
        downloadContract: [],

    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createContract.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(createContract.fulfilled, (state, action) => {
                state.isLoading = false;
                state.createcontract = action.payload;
            })
            .addCase(createContract.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })
            .addCase(getContractData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getContractData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.getcontractData = action.payload;
            })
            .addCase(getContractData.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })

            .addCase(getSinglePackage.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getSinglePackage.fulfilled, (state, action) => {
                state.isLoading = false;
                state.getsinglepackage = action.payload;
            })
            .addCase(getSinglePackage.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })
            .addCase(downloadContract.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(downloadContract.fulfilled, (state, action) => {
                state.isLoading = false;
                state.downloadContract = action.payload;
            })
            .addCase(downloadContract.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })
    },

});

export default QuoteSlice;
